import { Box, FormGroupLabel } from '@qbe/ads-core';
import React from 'react';
import { Control } from 'react-hook-form';

import CostcoMembershipNumberInput from '~/components/CostcoMembershipNumberInput';
import Email from '~/components/Email';
import MobileNumber from '~/components/MobileNumber';
import Name from '~/components/Name';
import FormSpacer from '~/components-ds/FormSpacer';
import { useAppContent, useAppSelector } from '~/hooks';
import { selectIsReferralCostco } from '~/selectors/selectAppDetails';
import { partialController } from '~/types/react-hook-form-helper';

interface PartialForm {
  firstName: string;
  lastName: string;
  mobileNumber: string;
  email: string;
  partnerMembershipNumber?: string;
}

interface ContactDetailsProps<T extends PartialForm> {
  control: Control<T>;
}

const ContactDetails = <T extends PartialForm>({ control }: ContactDetailsProps<T>) => {
  const isCostco = useAppSelector(selectIsReferralCostco);
  const partialControl = partialController<PartialForm, T>(control);
  const { getTextContent } = useAppContent({
    basePath: 'dsme.contactDetailsComponent',
  });

  return (
    <>
      <Box id="contact-details" />
      <FormGroupLabel title={getTextContent('title')} alignCenter />

      <Name control={partialControl} />
      <FormSpacer variant="input" />

      <MobileNumber control={partialControl} name="mobileNumber" />
      <FormSpacer variant="input" />

      <Email control={partialControl} name="email" />

      {isCostco && (
        <>
          <FormSpacer variant="input" />
          <CostcoMembershipNumberInput name="partnerMembershipNumber" control={partialControl} />
        </>
      )}
    </>
  );
};

export default ContactDetails;
